import { CEInvoiceLineAttributesBase } from './ce-invoice-line-attributes-base'


export class CEInvoiceLineAttributes extends CEInvoiceLineAttributesBase {

}